import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import NuevaMainForm from './mainForm'

const portletBreadcrumbs = [
  {
    name: 'Transferencias por Salida',
    path: `/${CodigosTransaccionesConstant.TRANSFERENCIAS_SALIDA_LISTA}`
  },
  {
    name: 'Nuevo'
  }
]

const NuevaTransferenciaPage = ({ location, history }) => {
  return (
    <>
      <Portlet>
        <Portlet.Header title='Transferencias por Salida' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <NuevaMainForm history={history} queryParams={location.search} />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default NuevaTransferenciaPage
